module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-floral-4-085cd5ad23cf9d7563c909e6e1c28367.webp";